function moneyMajor(cents) {
  return (Number(cents || 0) / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function bootCollection(root) {
  if (!root || root.dataset.booted === '1') return;
  root.dataset.booted = '1';

  const form = root.querySelector('[data-filter-form]');
  const sort = root.querySelector('[data-sort]');
  const grid = root.querySelector('[data-product-grid]');
  const views = root.querySelector('[data-grid-views]');
  const priceWrap = root.querySelector('[data-price-filter]');
  const collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
  const prefix = root.getAttribute('data-money-prefix') || 'Rs.';

  function submitFilters() {
    if (!form) return;
    const data = new FormData(form);
    const params = new URLSearchParams();
    data.forEach((value, key) => {
      if (value !== '' && value != null) params.append(key, String(value));
    });
    if (sort?.value) params.set('sort_by', sort.value);
    const qs = params.toString();
    window.location.href = qs ? `${collectionUrl}?${qs}` : collectionUrl;
  }

  form?.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.matches('input[type="checkbox"]')) submitFilters();
  });

  sort?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.href = url.toString();
  });

  // Price dual range
  if (priceWrap) {
    const minRange = priceWrap.querySelector('[data-price-min]');
    const maxRange = priceWrap.querySelector('[data-price-max]');
    const minHidden = priceWrap.querySelector('[data-price-min-hidden]');
    const maxHidden = priceWrap.querySelector('[data-price-max-hidden]');
    const minDisplay = priceWrap.querySelector('[data-price-min-display]');
    const maxDisplay = priceWrap.querySelector('[data-price-max-display]');
    const label = priceWrap.querySelector('[data-price-label]');
    let debounce = 0;

    function syncPrice(commit) {
      if (!minRange || !maxRange) return;
      let min = Number(minRange.value);
      let max = Number(maxRange.value);
      if (min > max) {
        const t = min;
        min = max;
        max = t;
        minRange.value = String(min);
        maxRange.value = String(max);
      }
      if (minHidden) minHidden.value = String(min);
      if (maxHidden) maxHidden.value = String(max);
      if (minDisplay) minDisplay.value = `${prefix}${moneyMajor(min)}`;
      if (maxDisplay) maxDisplay.value = `${prefix}${moneyMajor(max)}`;
      if (label) label.textContent = `Price: ${prefix}${moneyMajor(min)} – ${prefix}${moneyMajor(max)}`;
      if (commit) {
        window.clearTimeout(debounce);
        debounce = window.setTimeout(submitFilters, 350);
      }
    }

    minRange?.addEventListener('input', () => syncPrice(false));
    maxRange?.addEventListener('input', () => syncPrice(false));
    minRange?.addEventListener('change', () => syncPrice(true));
    maxRange?.addEventListener('change', () => syncPrice(true));

    function parseDisplay(value) {
      const n = Number(String(value || '').replace(/[^\d.]/g, ''));
      return Number.isFinite(n) ? Math.round(n * 100) : null;
    }

    minDisplay?.addEventListener('change', () => {
      const cents = parseDisplay(minDisplay.value);
      if (cents == null || !minRange) return;
      minRange.value = String(Math.max(0, Math.min(cents, Number(maxRange?.value || cents))));
      syncPrice(true);
    });
    maxDisplay?.addEventListener('change', () => {
      const cents = parseDisplay(maxDisplay.value);
      if (cents == null || !maxRange) return;
      maxRange.value = String(Math.max(Number(minRange?.value || 0), cents));
      syncPrice(true);
    });
  }

  // Grid density
  let storedCols = null;
  try {
    storedCols = window.localStorage.getItem('artink-col-cols');
  } catch {
    /* storage unavailable */
  }
  function setCols(cols) {
    if (!grid || !views) return;
    grid.setAttribute('data-cols', String(cols));
    views.querySelectorAll('[data-cols]').forEach((btn) => {
      const on = btn.getAttribute('data-cols') === String(cols);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    try {
      window.localStorage.setItem('artink-col-cols', String(cols));
    } catch {
      /* storage unavailable */
    }
  }
  if (storedCols) setCols(storedCols);
  views?.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cols]');
    if (!btn) return;
    setCols(btn.getAttribute('data-cols'));
  });

  // Quick add
  root.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-add-to-cart]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const url = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Add failed');
      }
      // Open the header cart so shoppers see the item was added.
      if (window.ArtinkCart?.openDropdown) {
        await window.ArtinkCart.openDropdown();
      } else if (window.ArtinkCart?.refresh) {
        await window.ArtinkCart.refresh();
      }
    } catch (error) {
      console.warn('[artink-collection]', error);
      window.alert(error.message || 'Could not add to cart');
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  root._artinkCollectionCleanup = () => {
    root.dataset.booted = '0';
  };
}

function initAll() {
  document.querySelectorAll('[data-artink-collection]').forEach(bootCollection);
}

initAll();
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-artink-collection]').forEach(bootCollection);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-collection]').forEach((root) => {
    root._artinkCollectionCleanup?.();
  });
});
